import { ApiResponse, PaginationResponse } from '../../../../constants/types';
import { LmsClassGroupType } from '../../../../constants/types/lms-type';
import { studentType } from '../../../../constants/types/student-type';
import instance from '../../../axios/utils.ts/instance';
import { getErrorMessages } from '../../util-func';

/**
 * [교사 LMS > 학생 관리 > 반 관리] 반 목록 조회
 * @param classId
 * @returns
 */
export const getClassGroupList = async (
  classId: string,
  params?: {
    isActive?: boolean;
  },
) => {
  try {
    // api 응답이 페이지네이션 데이터인데, 화면에서 페이지네이션 필요 없음. 충분히 큰 수로 설정
    const queryParams = {
      page: 1,
      pageSize: 1000,
      ...params,
    };
    const rtn = await instance.get<
      ApiResponse<PaginationResponse<LmsClassGroupType[]>>
    >(`/v1/lms/${classId}/class-group`, { params: queryParams });
    return rtn.data.data;
  } catch (e) {
    console.error(getErrorMessages(e));
  }
};

export type CreateClassGroupRequest = {
  name: string;
  description: string;
};

/**
 * [교사 LMS > 학생 관리 > 반 관리] 반 추가
 * @param classId
 * @param body
 * @returns
 */
export const createClassGroup = async (
  classId: string,
  body: CreateClassGroupRequest,
) => {
  const result = await instance.post(`/v1/lms/${classId}/class-group`, body);
  return result.data;
};

/**
 * [교사 LMS > 학생 관리 > 반 관리] 반 삭제
 * @param classId
 * @param id
 * @returns
 */
export const deleteClassGroup = async (classId: string, id: number) => {
  const result = await instance.delete(`/v1/lms/${classId}/class-group/${id}`);
  return result.data;
};

export type UpdateClassGroupRequest = {
  name: string;
  description: string;
  isActive: boolean;
};

/**
 * [교사 LMS > 학생 관리 > 반 관리] 반 수정
 * @param classId
 * @param id
 * @param params
 * @returns
 */
export const updateClassGroup = async (
  classId: string,
  id: number,
  params: UpdateClassGroupRequest,
) => {
  const result = await instance.put(
    `/v1/lms/${classId}/class-group/${id}`,
    params,
  );
  return result.data;
};

/**
 * [교사 LMS > 반 관리] 특정 반에 배정된 학생 목록 조회
 *
 * 반 상세(수정) 모달에서 "이 반에 누가 있는지" 보여줄 때 쓴다.
 * 상태(수강생/정지/대기생)를 가리지 않고 해당 반에 배정된 학생을 모두 가져온다.
 * @param classId
 * @param classGroupId
 * @returns
 */
export const getStudentsByClassGroup = async (
  classId: string,
  classGroupId: number,
) => {
  const rtn = await instance.get<
    ApiResponse<PaginationResponse<studentType[]>>
  >(`/v1/lms/${classId}/student`, {
    // 반 하나에 담기는 인원은 많지 않으므로 한 번에 받는다.
    params: { page: 1, pageSize: 1000, classGroupId },
  });
  return rtn.data.data;
};

export type UpdateClassGroupOrderRequest = {
  classGroupIds: number[];
};

/**
 * [교사 LMS > 학생 관리 > 반 관리] 반 노출 순서 변경
 * @param classId
 * @param body
 * @returns
 */
export const updateClassGroupOrder = async (
  classId: string,
  body: UpdateClassGroupOrderRequest,
) => {
  const result = await instance.put(
    `/v1/lms/${classId}/class-group/order`,
    body,
  );
  return result.data;
};
